import CheckIcon from '@mui/icons-material/Check';
import TuneIcon from '@mui/icons-material/Tune';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fab,
  IconButton,
  Paper,
  Slide,
  Stack,
} from '@mui/material';
import React, { forwardRef, useState } from 'react';

import Loader from 'FRONTEND/components/Loader';
import i18n from 'FRONTEND/utils/i18n';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

const Toolbar = ({ children, isMenu, title, isLoading }) => {
  const [isFilterDialogOpen, setIsFilterDialogOpen] = useState(false);
  const handleFiltersButtonClick = () => {
    setIsFilterDialogOpen(true);
  };

  const handleFilterMenuClose = () => {
    setIsFilterDialogOpen(false);
  };

  return isMenu ? (
    <>
      <Dialog open={isFilterDialogOpen} onClose={handleFilterMenuClose} TransitionComponent={Transition}>
        {title && (
          <DialogTitle>{title}</DialogTitle>
        )}
        <DialogContent>
          <Stack spacing={2} alignItems='center'>
            {children}
          </Stack>
        </DialogContent>
        <DialogActions>
          <IconButton
            color='primary'
            onClick={handleFilterMenuClose}
            aria-label='ok'
            className='toolbar-dialogClose'
            size='large'
          >
            <CheckIcon />
          </IconButton>
        </DialogActions>
      </Dialog>
      <Box>
        <Fab aria-label='open filters' color='primary' onClick={handleFiltersButtonClick} disabled={isLoading} size='small' sx={{ mt: 1 }}>
          {isLoading ? (
            <Loader
              isLoading={isLoading}
              size='small'
              noBackground
            />
          ) : (
            <TuneIcon />
          )}
        </Fab>
      </Box>
    </>
  ) : (
    <>
      <Box display='flex' justifyContent='space-between' flexShrink={0}>
        <Paper
          className='toolbar'
          square
          elevation={0}
          sx={{ backgroundColor: (theme) => theme.palette.grey[100] }}
        >
          <Stack direction='row' justifyContent='space-between' alignItems='center' spacing={2} width='100%' my={1}>
            {children}
          </Stack>
        </Paper>
        {isLoading &&
          <Box marginRight='10px' display='flex' alignItems='center' flexShrink={0}>
            <Loader
              isLoading
              position='verticalFlow'
              size='small'
              label={i18n._('Synchronization in progress...')}
              noBackground
            />
          </Box>}
      </Box>
    </>
  );
};

export default Toolbar;
